export const markName = 'inline-comment';
